define(['modules/common/controls/control'], (Control) => Control.extend({
    binders: {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.val());
                };
                view.$el.on('change', this.callback);
            },
            unbind (view) {
                view.$el.off('change', this.callback);
            },
            routine (view, value) {
                view.val(value);
            }
        },

        // Same as value binding, but publishing occurs only after Select2 closing
        valueEx: {
            bind (view, publish) {
                const context = {was_opened: false, was_changed: false};

                this.openCallback = function () {
                    context.was_opened = true;
                };

                this.changeCallback = function () {

                    /*
                     * If change event is fired without opening, it means that we have removed item by clicking
                     * on a cross sign, and data should be published immediately
                     */
                    if (!context.was_opened) {
                        publish(view.val());
                        context.was_changed = false;
                    } else {
                        context.was_changed = true;
                    }
                };

                this.closeCallback = function () {
                    if (context.was_opened && context.was_changed) {
                        publish(view.val());
                    }
                    context.was_changed = false;
                    context.was_opened = false;
                };

                view.$el.on('change', this.changeCallback);
                view.$el.on('select2-open', this.openCallback);
                view.$el.on('select2-close', this.closeCallback);
            },
            unbind (view) {
                view.$el.off('select2-close', this.closeCallback);
                view.$el.off('select2-open', this.openCallback);
                view.$el.off('change', this.changeCallback);
            },
            routine (view, value) {
                view.val(value);
            }
        },
        data: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.data());
                };
                view.$el.on('change', this.callback);
            },
            unbind (view) {
                view.$el.off('change', this.callback);
            },
            routine (view, value) {
                view.data(value);
            }
        },
        enabled (view, value) {
            view.setEnabled(Boolean(value));
        },
        toggle (view, value) {
            view.$el.select2('container').toggle(value);
        }
    },

    tagName: 'input',
    attributes: {type: 'hidden'},
    events: {
        change: 'removeErrors'
    },

    // Proxy to .select2('val', ...)
    val () {
        [].unshift.call(arguments, 'val');
        return this.$el.select2.apply(this.$el, arguments);
    },

    // Proxy to $.on(...)
    on () {
        return this.$el.on.apply(this.$el, arguments);
    },

    // Proxy to .select2('data', ...)
    data () {
        [].unshift.call(arguments, 'data');
        return this.$el.select2.apply(this.$el, arguments);
    },

    // Proxy to .select2('dropdown', ...)
    dropdown () {
        [].unshift.call(arguments, 'dropdown');
        return this.$el.select2.apply(this.$el, arguments);
    },

    // Proxy to .select2('close', ...)
    close () {
        [].unshift.call(arguments, 'close');
        return this.$el.select2.apply(this.$el, arguments);
    },

    // Proxy to .select2('open', ...)
    open () {
        [].unshift.call(arguments, 'open');
        return this.$el.select2.apply(this.$el, arguments);
    },

    enable () {
        return this.$el.select2('enable');
    },

    disable () {
        return this.$el.select2('disable');
    },

    setEnabled (enabled) {
        return enabled ? this.enable() : this.disable();
    }

}));
